import api from './apiConfig';

// Get Google User Info (from Google API, not backend)
export const getGoogleUserInfo = async (accessToken) => {
  try {
    const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch Google user info');
    }
    
    const data = await response.json();
    return {
      success: true,
      data: {
        email: data.email,
        name: data.name,
        givenName: data.given_name,
        familyName: data.family_name,
        picture: data.picture,
        emailVerified: data.email_verified,
        locale: data.locale,
      },
    };
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
};

// Learner Google Login
export const loginLearnerWithGoogle = async (googleData) => {
  try {
    const response = await api.post('/frontsite-api/v1/auth/learner-google', {
      data: {
        'access-token': googleData.accessToken,
        email: googleData.email,
        name: googleData.name,
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Learner Login (deprecated - use loginLearnerWithGoogle)
export const loginLearner = loginLearnerWithGoogle;

// Management Google Login
export const loginManagementWithGoogle = async (googleData) => {
  try {
    const response = await api.post('/frontsite-api/v1/auth/management', {
      data: {
        'access-token': googleData.accessToken,
        email: googleData.email,
        name: googleData.name,
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Management Login (deprecated - use loginManagementWithGoogle)
export const loginManagement = async (credentials) => {
  try {
    const response = await api.post('/frontsite-api/v1/auth/management/login', credentials);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Logout
export const logout = async () => {
  try {
    const response = await api.post('/frontsite-api/v1/auth/logout');
    localStorage.removeItem('token');
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

